import TagFunctions from './TagFunctions'

const TAG = `(function(d,t) {
    var BASE_URL="https://chat.celetus.com";
    var g=d.createElement(t),s=d.getElementsByTagName(t)[0];
    g.src=BASE_URL+"/packs/js/sdk.js";
    g.async = true;
    s.parentNode.insertBefore(g,s);
    g.onload=function(){
      window.chatwootSDK.run({
        websiteToken: 'DHPfobKJri3KTUTCDqAMtLhy',
        baseUrl: BASE_URL
      })
    }
  })(document,"script");`

const addTagDash = () => {
  const tag = TagFunctions.addScriptHeader(TAG)
  return [tag]
}

const ChatwootFunctions = {
  addTagDash,
}

export default ChatwootFunctions
